import { Roles } from '@shared/types'

export enum LegalActStrings {
  publisherNumber = 'Nr publikatora',
  legalArticle = 'art./ §',
  legalArticleTitle = 'Dokumenty',
}

export enum RequirementForms {
  title = 'Tytuł',
  lexUrl = 'Link',
}

export const ROLES_WITHOUT_CLIENT_BASIC = [
  Roles.Admin,
  Roles.Auditor,
  Roles.Client,
  Roles.ClientEditor,
  Roles.ClientAdministrator,
]

export const NO_OPTIONS_PLACEHOLDER = 'Brak dostępnej pozycji'
